module.exports = __webpack_public_path__ + "img/2025-0416-03-01.608c60d2.png";